import Layout from "components/Layout";
import React from "react";
import SiteEditDataTable from "./components/SiteEditDataTable";

function Site() {
  return (
    <Layout title="현장(오브젝트) 편집">
      <SiteEditDataTable />
    </Layout>
  );
}

export default Site;
